import React from 'react';
import Button from '../ui/Button';
import { MessageCircleIcon, GlobeIcon } from 'lucide-react';
import { trackContact } from '../tracking/metaPixel';
import { useLanguage } from '../../context/LanguageContext';
import { getWhatsAppLink } from '../../utils/whatsappLink';
const Header = () => {
  const {
    t,
    language,
    toggleLanguage
  } = useLanguage();
  const handleCtaClick = () => {
    trackContact({
      location: 'header',
      language,
      action: 'scroll_to_form'
    });
  };
  return <header className="bg-premium-gradient text-white py-3 px-4 sticky top-0 z-50 shadow-md" data-id="element-37">
      <div className="container mx-auto flex items-center justify-between" data-id="element-38">
        {/* Logo Area - Simplified for mobile */}
        <div className="font-heading font-bold text-lg md:text-xl tracking-tight" data-id="element-39">
          Pedro <span className="text-accent" data-id="element-40">de la Cruz</span>
        </div>

        <div className="flex items-center gap-3 md:gap-4" data-id="element-41">
          {/* Language Toggle */}
          <button onClick={toggleLanguage} className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors text-sm font-medium" aria-label="Switch language" data-id="element-42">
            <GlobeIcon className="w-4 h-4 text-accent" data-id="element-43" />
            <span data-id="element-44">{language === 'es' ? 'Español' : 'English'}</span>
          </button>

          {/* Desktop CTA - Now scrolls to form */}
          <div className="hidden md:block" data-id="element-45">
            <Button href="#lead-form" variant="success" className="bg-[#25D366] hover:bg-[#20bd5a] shadow-md font-bold" onClick={handleCtaClick} data-id="element-46">
              {language === 'es' ? 'Solicita tu carro' : 'Get your car'}{' '}
              <MessageCircleIcon className="w-4 h-4 ml-2" data-id="element-47" />
            </Button>
          </div>

          {/* Mobile CTA (icon only) - Now scrolls to form */}
          <div className="md:hidden" data-id="element-48">
            <a href="#lead-form" className="inline-flex items-center justify-center p-2 rounded-full bg-[#25D366] text-white shadow-lg animate-pulse" aria-label={t.header.ctaMobileLabel} onClick={handleCtaClick} data-id="element-49">
              <MessageCircleIcon className="w-6 h-6" data-id="element-50" />
            </a>
          </div>
        </div>
      </div>
    </header>;
};
export default Header;